<template>
  <section class="move-card overflow-hidden !p-0">
    <div
      class="flex items-center justify-between gap-3 px-5 py-4 border-b"
      style="border-color: var(--move-border)"
    >
      <div class="min-w-0">
        <h3 class="text-sm font-bold move-text">{{ title }}</h3>
        <p v-if="subtitle" class="text-xs move-text-faint mt-0.5">{{ subtitle }}</p>
      </div>
      <router-link
        to="/production/productions"
        class="text-sm font-semibold shrink-0"
        style="color: var(--move-accent)"
      >
        View all
      </router-link>
    </div>
    <div v-if="!items.length" class="move-empty-state py-12 px-5">
      <span class="material-icons">{{ emptyIcon }}</span>
      <p class="font-semibold move-text">{{ emptyTitle }}</p>
      <p class="text-sm move-text-faint mt-1 max-w-sm">{{ emptyBody }}</p>
    </div>
    <ul v-else class="divide-y" style="border-color: var(--move-border)">
      <li v-for="item in items" :key="item.id" class="px-5 py-3.5">
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0">
            <router-link
              :to="`/production/productions/${item.id}`"
              class="font-semibold move-text hover:text-[var(--move-accent)] truncate block"
            >
              {{ item.name }}
            </router-link>
            <p class="text-xs move-text-faint mt-0.5 truncate">
              {{ item.project?.name || 'No project' }}
            </p>
          </div>
          <span :class="statusBadgeClass(item.status)" class="shrink-0">
            {{ productionStatusLabels[item.status] || item.status }}
          </span>
        </div>
        <ProductionGaps
          class="mt-2"
          :gaps="item.gaps"
          :production-id="item.id"
          linked
        />
      </li>
    </ul>
  </section>
</template>

<script setup>
/* global defineProps */
import ProductionGaps from './ProductionGaps.vue'
import { productionStatusLabels, statusBadgeClass } from '../../config/productionNavigation'

defineProps({
  items: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: 'Needs attention'
  },
  subtitle: {
    type: String,
    default: 'Missing people, scenes, or a shoot day — tap a chip to jump in.'
  },
  emptyIcon: {
    type: String,
    default: 'check_circle'
  },
  emptyTitle: {
    type: String,
    default: 'Nothing blocking a shoot'
  },
  emptyBody: {
    type: String,
    default: 'Every production has the people and pieces it needs. Open productions to keep going.'
  }
})
</script>
